<template>
	<div>
		<div class="arp-controle-saldos-orgao-filtro">
			<v-col cols="3">
				<v-autocomplete
					clearable
					dense
					:items="orgaos"
					:filter="orgaoFilter"
					v-model="filtros.idOrgao"
					item-value="id"
					item-text="siglaDescricao"
					label="Filtro por Órgão"
					@click:clear="removerIdOrgaoFiltro"
					@input="setIdOrgaoFiltro"
					hide-details
					outlined
				></v-autocomplete>
			</v-col>

			<div>
				<az-search
					:filter="filtro"
					simple-search-placeholder="Busque por: tipo, código e item."
					@simple-search="setTipoCodigoOuDescricaoFiltro"
					ref="componenteAzSearch"
					@remove-filter="removerTipoCodigoOuDescricaoFiltro"
					keep-search-text
				></az-search>
			</div>
		</div>

		<ata-controle-saldos-orgao-listagem
			v-if="listagem.datasource.length"
			:items="listagem.datasource"
			:paginacao="listagem.paginacao"
			:total-itens="listagem.totalItens"
			:total-paginas="listagem.totalPaginas"
			@paginar="setPaginacaoListagem"
		></ata-controle-saldos-orgao-listagem>

		<az-container v-else>
			<template-listagem-vazia
				class="pb-4"
				:textos="texto"
				:total-itens="listagem.totalItens"
			></template-listagem-vazia>
		</az-container>
	</div>
</template>

<script>
import { actionTypes } from '@/core/constants'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import AtaControleSaldosOrgaoListagem from '@/views/pages/ata/acessar/gestao-da-ata/controle-saldos-orgao/listagem/ControleSaldosOrgaoListagem.vue'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'

export default {
	name: 'acessar-ata-controle-saldos-orgao-view',
	components: { TemplateListagemVazia, AtaControleSaldosOrgaoListagem },
	data() {
		return {
			isComponenteAtivo: true,
			orgaos: [],
			textoBuscaOrgao: '',
			filtros: {
				idOrgao: null,
				idAta: this.$route.params.id,
			},
			filtro: {
				filtro: '',
			},
			listagem: {
				datasource: [],
				totalPaginas: 1,
				totalItens: 0,
				paginacao: paginacaoListagem(['id'], 25),
			},
			texto: {
				mensagem: 'Selecione um órgão para visualizar o controle de saldos.',
			},
		}
	},
	async mounted() {
		await this.carregarOrgaos()
	},
	beforeDestroy() {
		this.isComponenteAtivo = false
	},
	methods: {
		async loadData() {
			try {
				if (this.filtros.idOrgao === null) {
					this.listagem.datasource = []
					this.listagem.totalPaginas = 1
					this.listagem.totalItens = 0
					return
				}

				const { itens, totalElements, totalPages } = await this.$store.dispatch(
					actionTypes.ATA.CONTROLE_SALDOS_ORGAO.BUSCAR_POR_FILTRO,
					{
						filtros: { ...this.filtros, ...this.filtro },
						paginacao: this.listagem.paginacao,
					},
				)
				this.listagem.datasource = itens
				this.listagem.totalItens = totalElements
				this.listagem.totalPaginas = totalPages
			} catch (Err) {
				throw new Error(Err)
			}
		},
		orgaoFilter(item, queryText) {
			const textOne = item.sigla.toLowerCase()
			const searchText = queryText.toLowerCase()
			this.textoBuscaOrgao = searchText
			return textOne.indexOf(searchText) > -1
		},
		async carregarOrgaos() {
			if (!this.isComponenteAtivo) return
			const { itens } = await this.$store.dispatch(
				actionTypes.ATA.CONTROLE_SALDOS_ORGAO.BUSCAR_ORGAOS_USUARIO,
				this.$route.params.id,
			)
			this.orgaos = itens

			if (itens.length === 1) {
				this.filtros.idOrgao = itens[0].id
				await this.loadData()
			}
		},
		async removerIdOrgaoFiltro() {
			this.filtros.idOrgao = null
			this.textoBuscaOrgao = ''
		},
		async removerTipoCodigoOuDescricaoFiltro() {
			this.filtro.filtro = ''
			await this.loadData()
		},
		async setIdOrgaoFiltro(idOrgao) {
			this.filtros.idOrgao = idOrgao
			await this.loadData()
		},
		async setTipoCodigoOuDescricaoFiltro(tipoCodigoOuDescricao) {
			this.filtro.filtro = tipoCodigoOuDescricao
			await this.loadData()
		},
		setPaginacaoListagem() {
			this.loadData()
		},
	},
}
</script>

<style lang="stylus">
.arp-controle-saldos-orgao-filtro
	margin 25px 0
	display flex
	place-content space-between
	align-items center
</style>
